import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsUsefulInformationResponse } from "../../Orchestrator/Types/Interface/ICmsUsefulInformaton";

export async function getCmsUsefulInformation(): Promise<
  IApiResponse<ICmsUsefulInformationResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getUsefulInformationAPI;

  const params = new URLSearchParams({
    "populate[help_icon][populate]": "*",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsUsefulInformationResponse>(endpointWithParams, "GET");
}
